// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '대우제약',
  targetSheetName: '2026년 06월',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  fillMergedDrugNameColumn: true,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험약가',
    commissionRate: '수수료율',
  },
  requiredHeaders: [
    '구 분',
    '제품명',
    '성분함량',
    '보험약가',
    '보험코드',
    '포장단위',
    '전문/일반',
    '대조약',
    '수수료율',
  ],
});
